import TeenagersDesktopContent from "./assets/teenagersDesktop.png";
import TeenagersMobileContent from "./assets/teenagersMobile.png";

import kidsDesktopContent from "./assets/kidsDesktop.png";
import kidsMobileContent from "./assets/kidsMobile.png";

export const PopupConfig = {
  teenagers: {
    desktopImage: TeenagersDesktopContent,
    mobileImage: TeenagersMobileContent,
    title: "landing.block-categories.popup.teenagers-title",
    alt: 'website image with content for teenagers'
  },
  kids: {
    desktopImage: kidsDesktopContent,
    mobileImage: kidsMobileContent,
    title: "landing.block-categories.popup.kids-title",
    alt: 'website image with content for kids'
  },
};



// WEBPACK FOOTER //
// ./src/js/components/pages/newLandingPage/ui/preview-popup/config.js